// @flow
import type { Element } from 'react';
import React from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import { EANHookSection } from './EANHookSection.js';
import { EANLaunchSection } from './EANLaunchSection.js';
import { EANExploreSection } from './EANExploreSection.js';
import { EANDiscussSection } from './EANDiscussSection.js';
import { Heading } from '../Heading.js';

export function EANClassroomGuide(props: {|
  children: [
    Element<typeof EANHookSection>,
    Element<typeof EANLaunchSection>,
    Element<typeof EANExploreSection>,
    Element<typeof EANDiscussSection>,
  ],
|}) {
  const { failedValidation } = usePropsValidation(props, EANClassroomGuide);
  if (failedValidation) return null;
  return (
    <div style={{ marginTop: 40 }}>
      <Heading>Classroom guide</Heading>
      {props.children}
    </div>
  );
}
EANClassroomGuide.spec = {
  children: t.exactOrderChildrenArray(
    t.elementType(EANHookSection),
    t.elementType(EANLaunchSection),
    t.elementType(EANExploreSection),
    t.elementType(EANDiscussSection),
  ),
};
